
const pluginBundles = {
  "analytics-course": () => import(/* webpackChunkName: "analytics-course" */ "../gems/plugins/analytics/app/jsx/bundles/course.js"),
  "analytics-department": () => import(/* webpackChunkName: "analytics-department" */ "../gems/plugins/analytics/app/jsx/bundles/department.js"),
  "analytics-student_in_course": () => import(/* webpackChunkName: "analytics-student_in_course" */ "../gems/plugins/analytics/app/jsx/bundles/student_in_course.js")
}
export default pluginBundles
